<template>
  <div class="tile">
    <MarketReportsMenu  :isEditable="isEditable"
                        :header="header"
                        @edit="handleEdit"
                        @undo="handleUndo"
                        @save="handleSave" />
    
    <div  class="table-line"
          style="margin-right: 1.5rem;"
          v-if="tableData">
      <div></div>
      <div><span><strong>{{ $t('Webportal.MarketReports.Planned') }}</strong></span></div>
      <div><span><strong>{{ $t('Webportal.MarketReports.Current') }}</strong></span></div>
    </div>
    
    <div  class="tile-content tile-scrollable">
      <!-- Schedule -->
      <!-- <div class="table-line">
        <div></div>
        <div><span><strong>{{ $t('Webportal.MarketReports.Planned') }}</strong></span></div>
        <div><span><strong>{{ $t('Webportal.MarketReports.Current') }}</strong></span></div>
      </div> -->
      <div class="table-line table-line-padding">
        <span><strong>{{ $t('Webportal.MarketReports.TimeSchedule') }}</strong></span>
      </div>
      <div class="table-line-sm" v-if="tableData">
        <span>{{ $t('Webportal.MarketReports.Start') }}</span>
        <div>
          <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon-red" /> -->
          {{ getDateFormatted(tableData.schedule.planned.start) }}
        </div>
        <div>
          <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon-red" /> -->
          {{ getDateFormatted(tableData.schedule.current.start) }}
        </div>
      </div>
      <div class="table-line-sm" v-if="tableData">
        <span>{{ $t('Webportal.MarketReports.End') }}</span>
        <div>
          <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon-red" /> -->
          {{ getDateFormatted(tableData.schedule.planned.end) }}
        </div>
        <div>
          <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon-red" /> -->
          {{ getDateFormatted(tableData.schedule.current.end) }}
        </div>
      </div>

      <!-- Visits -->
      <div  v-if="tableData && tableData.visits && tableData.visits.length > 0"
            class="table-line table-line-padding">
        <span><strong>{{ $t('Webportal.MarketReports.Visits') }}</strong></span>
      </div>
      <div  v-if="tableData && tableData.visits && tableData.visits.length > 0"
            class="table-line-sm">
        <span><strong>{{ $t('Webportal.MarketReports.Total') }}</strong></span>
        <div v-if="tableData.Planned">
          <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon-red" /> -->
            {{ tableData.Planned }}
          </div>
          <div v-else>
          </div>
          <div v-if="tableData.Current">
            <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon-red" /> -->
            {{ tableData.Current }}
          </div>
          <div v-else>
          </div>
      </div>
      <div  v-if="tableData && tableData.visits && tableData.visits.length > 0">
        <div  v-for="(brand, index) in tableData?.visits"
              :style="{ 'background-color': brand.color, 'color': 'white' }"
              :key="index">
          <div class="table-line-sm">
            {{ brand.Brand }}
          </div>
          <div  class="table-line-sm" 
                v-for="(item, j) in getFrequencies(brand)" :key="j">
            <span class="intended">{{ getFrequencyText(item.Frequency) }}</span>
            <div v-if="item.Planned">
              <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon" /> -->
              {{ item.Planned }}
            </div>
            <div v-else>
            </div>
            <div v-if="item.Current">
              <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon" /> -->
              {{ item.Current }}
            </div>
            <div v-else>
            </div>
          </div>
        </div>
      </div>

      <!-- Enquiry -->
      <div  v-if="tableData && tableData.enquiry && tableData.enquiry.length > 0"
            class="table-line table-line-padding">
        <span><strong>{{ $t('Webportal.MarketReports.EnquiryVehicles') }}</strong></span>
      </div>
      <div  v-if="tableData && tableData.enquiry && tableData.enquiry.length > 0">
        <div  v-for="(brand, index) in getEnquiryBrands(tableData?.enquiry)"
              :key="index"
              :style="{ 'background-color': brand.color, 'color': 'white' }" >
          <div class="table-line-sm">
            {{ brand.Brand }}
          </div>
          <div  class="table-line-sm" 
                v-for="(item, j) in getEnquiryItems(tableData.enquiry, brand.Brand)"
                :key="j">
            <span class="intended">{{ item.Model }}</span>
            <div v-if="item.Planned">
              <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon" /> -->
              {{ item.Planned }}%
            </div>
            <div v-else>
            </div>
            <div v-if="item.Current">
              <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon" /> -->
              {{ item.Current }}%
            </div>
            <div v-else>
            </div>
          </div>
        </div>
      </div>

      <!-- Optional Modules -->
      <div v-if="waveDetails && waveDetails.length > 0">
        <div class="table-line table-line-padding">
        </div>
        <div  v-for="(detail, i) of getWaveDetails" 
              :key="i">
          <div class="local-header">{{ detail.header }}</div>
          <ul class="audi-bullets">
            <li v-for="(item, j) of getDetailLines(detail)" :key="j">
              <font-awesome-icon :icon="['fas', 'chevron-right']" class="bullet-icon" />
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div  v-if="(!waveDetails || waveDetails.length > 0) && (!tableData || tableData.length > 0)" 
          class="tile-content tile-scrollable market-reports-no-data">
      {{ $t("Webportal.NoData") }}
    </div>

  </div>
</template>

<script>
import MarketReportsMixin from '@/mixins/MarketReportsMixin';

export default {
  mixins: [MarketReportsMixin],

  props: {
    configuration:    { type: Object, required: true },
    waveDetails:      { type: Array, required: true },
    tableData:        { type: Object, required: false }
  },

  computed: {
    getWaveDetails() {
      if (!this.waveDetails) {
        return [];
      }
      return this.waveDetails;
    }
  },

  methods: {
    getDetailLines(detail) {
      return detail.text.split('\n');
    },
    getDateFormatted(date) {
      const options = { year: 'numeric', month: 'short' };
      return new Date(date).toLocaleDateString('en-US', options);
    },
    getEnquiryBrands(items) {
      let result = [];
      for (const item of items || []) {
        let brand = result.find(x => x.Brand === item.Brand);
        if (!brand) {
          brand = { Brand: item.Brand, color: item.color };
          result.push(brand);
        }
      }
      return result;
    },
    getEnquiryItems(items, brand) {
      return items.filter(item => item.Brand === brand);
    },
    getFrequencyText(number) {
      switch (number) {
        case 1:
          return this.$t('Webportal.MarketReports.Once');
        case 2:
          return this.$t('Webportal.MarketReports.Twice');
        default:
          return `${number} ${this.$t('Webportal.MarketReports.Times')}`;
      }
    },
    getFrequencies(brand) {
      return _.sortBy(brand.frequencies, ['Frequency']);
    }
  }
};

</script>

<style scoped lang="scss">
.tile-content {
  height: calc(100% - 5.5rem)!important;
}

.local-header {
  font-size: 14px;
  font-weight: 700;
}

li{
  font-size: 12px;
}

.table-line, .table-line-sm {
  display: grid;
  grid-template-columns: 1fr 5rem 5rem;
}
.table-line-sm {
  font-size: 12px; 
  font-stretch: extra-condensed;
  font-weight: 800;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.table-line-padding {
  padding-top: 0.5rem; 
  padding-bottom: 0.25rem;
}
.intended {
  padding-left: 1rem;
}
</style>